import { KpiEntityName, Page } from '@/components';
import { tokensMapping } from '@/utils/tokens';
import { ArrowSwitchIcon, CryptoIcon, Flex, Heading } from '@blockanalitica/ui';
import HistoricTabs from './HistoricTabs';
import DAIEventsTable from './MKREventsTable';

export default function MKRSKYEventsPage() {
  return (
    <Page
      title={
        <Flex gap="2xs" alignItems="center">
          <KpiEntityName
            symbol1={<CryptoIcon name="MKR" size="3" />}
            symbol2={
              <CryptoIcon
                name="SKY"
                address={tokensMapping('SKY').address}
                size="3"
              />
            }></KpiEntityName>
          <Heading size="1">
            <Flex gap="xs" alignItems="center">
              MKR <ArrowSwitchIcon /> SKY Activity
            </Flex>
          </Heading>
        </Flex>
      }>
      <HistoricTabs />
      <DAIEventsTable />
    </Page>
  );
}
